<template>
	<v-tooltip  bottom>
		<template v-slot:activator="{ on }">
			<v-icon small class="icon" color="techIcon" v-on="on">{{icons[name]}}</v-icon>
		</template>
		<span>{{name}}</span>
	</v-tooltip>
   
</template>

<script>
  export default {
		name: 'Icon',
    props: {
			name:{
				type: String,
			}
			
		},
		data:function() {
			return {
				icons: {
					"React":"mdi-react",
					"Redux":"$vuetify.icons.redux",
					"Vue":"mdi-vuejs",
					"Firebase":"mdi-firebase",
					"Node":"mdi-nodejs",
					"Vuforia":"$vuetify.icons.vuforia",
					"AR Core":"$vuetify.icons.arcore",
					"Unity": "mdi-unity",
					"Arduino UNO":"$vuetify.icons.arduino",
					"Bela":"$vuetify.icons.bela",
					"Pure Data":"$vuetify.icons.puredata",
					"Phaser":"$vuetify.icons.phaser",
					"D3":"$vuetify.icons.d3"
				}
			};
		},
	
  }
</script>

<style scoped>
.icon{
	width: 36px; 
	height: 36px; 
	margin:0; 
}
</style>


